import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useSupabaseQuery } from '../../hooks/useSupabaseQuery';
import { PageHeader } from '../../components/ui/PageHeader';
import { EmptyState } from '../../components/ui/EmptyState';
import type { ProveedorRow } from '../../types/database.types';

/** Módulo de Proveedores (DAF v2, sección 18). Escritura admin-only —
 * política RLS `proveedores_admin` en schema.sql. */
export function ProveedoresList() {
  const { data, loading, error } = useSupabaseQuery<ProveedorRow[]>(async () => {
    const { data, error } = await supabase.from('proveedores').select('*').neq('estado', 'anulado').order('nombre');
    return { data, error };
  });

  return (
    <div>
      <PageHeader
        title="Proveedores"
        description="Proveedores de productos e insumos — DAF v2, sección 18"
        actions={
          <div className="flex gap-2">
            <Link to="/admin/compras" className="btn-secondary">
              Ver compras
            </Link>
            <Link to="/admin/proveedores/nuevo" className="btn-primary">
              Nuevo proveedor
            </Link>
          </div>
        }
      />

      {loading && <p className="text-sm text-onyx/50">Cargando…</p>}
      {error && <p className="text-sm text-red-600">{error}</p>}

      {data && data.length === 0 && (
        <EmptyState title="No hay proveedores registrados" description="Crea el primero desde el botón de arriba." />
      )}

      {data && data.length > 0 && (
        <div className="card overflow-x-auto p-0">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-onyx/10 text-left text-onyx/50">
                <th className="px-4 py-3 font-medium">Nombre</th>
                <th className="px-4 py-3 font-medium">NIT / Documento</th>
                <th className="px-4 py-3 font-medium">Teléfono</th>
                <th className="px-4 py-3 font-medium">Correo</th>
                <th className="px-4 py-3" />
              </tr>
            </thead>
            <tbody>
              {data.map((p) => (
                <tr key={p.id} className="border-b border-onyx/5 last:border-0 hover:bg-onyx/[0.02]">
                  <td className="px-4 py-3 font-medium text-onyx">{p.nombre}</td>
                  <td className="px-4 py-3 text-onyx/70">{p.documento_nit ?? '—'}</td>
                  <td className="px-4 py-3 text-onyx/70">{p.telefono ?? '—'}</td>
                  <td className="px-4 py-3 text-onyx/70">{p.email ?? '—'}</td>
                  <td className="px-4 py-3 text-right">
                    <Link to={`/admin/proveedores/${p.id}`} className="text-gold-deep hover:underline">
                      Editar
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
